import { useSetting, useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104 } from "@faire/web-api--source/indigofair/settings/NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104";
export var useSettingNewEmailUnsubscribePreferencePage = function() {
    return useSetting(NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104, false);
};
export var useAssignSettingNewEmailUnsubscribePreferencePage = function() {
    return useAssignSetting(NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104);
};
